/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommunicationCommunicationEntryPermissions } from './communicationCommunicationEntryPermissions';
import { CommunicationCommunicationRecipientPermissions } from './communicationCommunicationRecipientPermissions';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CommunicationPermissions { 
    communicationEntry: CommunicationCommunicationEntryPermissions;
    communicationRecipient: CommunicationCommunicationRecipientPermissions;
}
export const CommunicationPermissions_communicationEntry_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationPermissions_communicationRecipient_Validators: ValidatorFn[] =
    [  Validators.required, ];


